

























































import {vxm} from "@/store";
import {Component, Vue, Prop} from 'vue-property-decorator';
import {KeyValue} from "@shared_vue/types/KeyValue";


@Component
export default class InsuranceCard extends Vue {
  @Prop(Number) readonly id: number | undefined;
  @Prop(String) readonly src: string | undefined;
  @Prop({default: 'true'}) readonly showButton : boolean | undefined;
  @Prop(String) readonly title: string | undefined;
  @Prop(String) readonly description: string | undefined;
  @Prop(String) readonly btnText: string | undefined;
  @Prop() readonly buttonFunction: Function | undefined;
  private ui = vxm.ui;
  private expanded = false;
  //note these dynamic static assets will likely be served from S3

  private publicPath = process.env.VUE_APP_STATIC_DIR;
  private keyValues: KeyValue[] = [new KeyValue('Option1','Val1'),new KeyValue('Option2','Val2')]


  private expand(){
    if (this.buttonFunction) //rather use emit?
      this.buttonFunction(this.id);
    this.expanded = !this.expanded;
    console.log(JSON.stringify(this.keyValues[0]))
  }
private save(){
  this.expanded = !this.expanded;
}

}
